import MuiAlert from '@mui/material/Alert';
import React from 'react';

export const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
